import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, Effect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';

import {
    getDokumentBearbeitenBerechtigungenSelected, getDokumentLeseBerechtigungenSelected, getDokumentSelected, getPandemieCheck,
    getPandemieLevelStichtag, getSelectedAufgaben, getSelectedPandemieLevelId, getVeranstaltungenDetail
} from './veranstaltungen.selectors';
import {WsCommandSucceededAction, WS_COMMAND_SUCCEEDED} from '../../websocket.actions';
import * as fromAuthModule from '@orga-app/auth/reducer';
import {LoadingController} from '@ionic/angular';
import {filter, map, tap, withLatestFrom} from 'rxjs/operators';
import {GetVeranstaltungFunktionsbereichAufgabenBenutzerBerechtigungenAdminAction, POST_VERANSTALTUNG_KOPIEREN, PostDokumentBearbeitenBerechtigungEntfernenMultiAction, PostDokumentBerechtigungEntfernenMultiAction, PostVeranstaltungKopierenAction} from '../../../client-ngrx/veranstaltungen';
import {BENUTZER_BERECHTIGUNGEN_ENTFERNEN, BENUTZER_BERECHTIGUNGEN_HINZUFUEGEN, BenutzerberechtigungenEntfernenAction, BenutzerberechtigungenHinzufuegenAction, DOKUMENT_BEARBEITEN_BERECHTIGUNGEN_ENTFERNEN, DOKUMENT_LESE_BERECHTIGUNGEN_ENTFERNEN, FUNKTIONSBEREICH_SETZEN, FunktionsbereichSetzenAction, PANDEMIE_LEVEL_ABFRAGEN, PANDEMIE_LEVEL_EINSTELLEN} from './veranstaltungen.actions.ui';
import { PostVeranstaltungPandemieCheckAction, PostVeranstaltungPandemieLevelSetzenAction} from '../../../client-ngrx/pandemie';
import * as apiVeranstaltungen from './../../../clients/veranstaltungen';
import {PageState} from './veranstaltungen.reducer';
import {Observable} from 'rxjs';
import {PostAufgabenBenutzerBerechtigungenEntfernenAction, PostAufgabenBenutzerBerechtigungenHinzufuegenAction} from '../../../client-ngrx/veranstaltungen';
import {AufgabenBenutzerIdsRequest} from '../../../clients/veranstaltungen';
import {getIstPandemieLizenzAktiv} from '@orga-app/mandant/reducer';

@Injectable()
export class VeranstaltungenPageUiEffects {
    loading: any; // Loading;


    // VERANSTALTUNG KOPIEREN
    @Effect({dispatch: false})
    VeranstaltungKopieren$ = this.actions$.pipe(
        ofType(POST_VERANSTALTUNG_KOPIEREN),
        tap(async (x: PostVeranstaltungKopierenAction) => {
            this.loading = await this.loadingCtrl.create({
                spinner: 'dots',
                message: 'Veranstaltung wird kopiert'
            });

            await this.loading.present();
            setTimeout(function() {
                if (this.loading !== undefined && this.loading !== null) {
                    this.loading.dismiss();
                    this.loading = null;
                }
            }.bind(this), 5000);
        })
    );
    @Effect({dispatch: false})
    commandSuccedded$ = this.actions$.pipe(
        ofType(WS_COMMAND_SUCCEEDED),
        map(x => <WsCommandSucceededAction> x),
        filter(x => x.message !== null),
        filter(x => x.message !== undefined),
        filter(x => x.message.command_type === 'VeranstaltungKopierenCommand'),
        tap((x: WsCommandSucceededAction) => {
            if (this.loading !== undefined && this.loading !== null) {
                this.loading.dismiss();
                this.loading = null;
            }
        })
    );

    @Effect()
    leseBerechtigungenEntfernen$ = this.actions$.pipe(
        ofType(DOKUMENT_LESE_BERECHTIGUNGEN_ENTFERNEN)
        , withLatestFrom(this.store$.pipe(select(getDokumentSelected)),
            this.store$.pipe(select(getDokumentLeseBerechtigungenSelected)))
        , map(([x, dokument, leseBerechtigungen]) => {
            const request = <apiVeranstaltungen.DokumentBerechtigungMultiRequest>{
                dokument_id: dokument.dokument_id,
                veranstaltung_id: dokument.veranstaltung_id,
                zeitpunkt_utc: new Date(),
                rolle_ids: leseBerechtigungen
            };
            return new PostDokumentBerechtigungEntfernenMultiAction(request);
        })
    );

    @Effect()
    bearbeitenBerechtigungenEntfernen$ = this.actions$.pipe(
        ofType(DOKUMENT_BEARBEITEN_BERECHTIGUNGEN_ENTFERNEN)
        , withLatestFrom(this.store$.pipe(select(getDokumentSelected)),
            this.store$.pipe(select(getDokumentBearbeitenBerechtigungenSelected)))
        , map(([x, dokument, bearbeitenBerechtigungen]) => {
            const request = <apiVeranstaltungen.DokumentBerechtigungMultiRequest>{
                dokument_id: dokument.dokument_id,
                veranstaltung_id: dokument.veranstaltung_id,
                zeitpunkt_utc: new Date(),
                rolle_ids: bearbeitenBerechtigungen
            };
            return new PostDokumentBearbeitenBerechtigungEntfernenMultiAction(request);
        })
    );

    @Effect()
    pandemieLevelAbfrage$ = this.actions$.pipe(
        ofType(PANDEMIE_LEVEL_ABFRAGEN)
        , withLatestFrom(this.store$.pipe(select(getVeranstaltungenDetail)),
            this.store$.pipe(select(getPandemieLevelStichtag)),
            this.store$.pipe(select(getIstPandemieLizenzAktiv)))
        , filter(([x, detail, stichtag, istPandmieAktiv]) => istPandmieAktiv)
        , map(([x, detail, stichtag]) => {
            const stichtagToPost = new Date(Date.UTC(stichtag.getFullYear(), stichtag.getMonth(), stichtag.getDate()));
            return new PostVeranstaltungPandemieCheckAction({
                veranstaltung_id: detail.veranstaltung_id,
                stichtag_utc: stichtagToPost
            });
        })
    );

    @Effect()
    pandemieLevelEinstellen$ = this.actions$.pipe(
        ofType(PANDEMIE_LEVEL_EINSTELLEN)
        , withLatestFrom(this.store$.pipe(select(getVeranstaltungenDetail)),
            this.store$.pipe(select(getSelectedPandemieLevelId)),
            this.store$.pipe(select(getPandemieCheck)),
            this.store$.pipe(select(getPandemieLevelStichtag)))
        , map(([x, detail, pandemieLevel, pandemieCheck, stichtag]) => {
            const stichtagToPost = new Date(Date.UTC(stichtag.getFullYear(), stichtag.getMonth(), stichtag.getDate()));
            return new PostVeranstaltungPandemieLevelSetzenAction({
                veranstaltung_id: detail.veranstaltung_id,
                pandemie_level_id: pandemieLevel,
                pandemie_check_result: pandemieCheck,
            });
        })
    );

    funktionsbereichSetzen$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<FunktionsbereichSetzenAction>(FUNKTIONSBEREICH_SETZEN)
        , withLatestFrom(this.store$.pipe(select(getVeranstaltungenDetail)))
        , filter(([x, detail]) => detail !== null && detail.veranstaltung_id !== null)
        , map(([x, detail]) => {
            return new GetVeranstaltungFunktionsbereichAufgabenBenutzerBerechtigungenAdminAction(detail.veranstaltung_id, x.fbId);
        })));

    benutzerHinzufuegen$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<BenutzerberechtigungenHinzufuegenAction>(BENUTZER_BERECHTIGUNGEN_HINZUFUEGEN),
        withLatestFrom(this.store$.pipe(select(getSelectedAufgaben))),
        filter(([x, selectedAufgaben]) => x.payload !== null && x.payload.length > 0
            && selectedAufgaben !== null && selectedAufgaben.length > 0),
        map(([x, selectedAufgaben]) => {
            const request = <AufgabenBenutzerIdsRequest> {
                benutzer_id_liste: x.payload,
                aufgabe_id_liste: selectedAufgaben
            };
            return new PostAufgabenBenutzerBerechtigungenHinzufuegenAction(request);
        })
    ));

    benutzerEntfernen$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<BenutzerberechtigungenEntfernenAction>(BENUTZER_BERECHTIGUNGEN_ENTFERNEN),
        withLatestFrom(this.store$.pipe(select(getSelectedAufgaben))),
        filter(([x, selectedAufgaben]) => selectedAufgaben !== null && selectedAufgaben.length > 0),
        map(([x, selectedAufgaben]) => {
            const request = <AufgabenBenutzerIdsRequest> {
                benutzer_id_liste: [x.payload.benutzer_id],
                aufgabe_id_liste: selectedAufgaben
            };
            return new PostAufgabenBenutzerBerechtigungenEntfernenAction(request);
        })
    ));

    constructor(private actions$: Actions,
                private store$: Store<PageState>,
                private storeAuth: Store<fromAuthModule.ModuleState>,
                public loadingCtrl: LoadingController,
                private injector: Injector) {
    }
}
